// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetClassesRequestModel from '../../model/get-classes-request-model';
import GetClassesRequestDTO from '../dto/get-classes-request-dto';
import dtoSchema from '../schemas/get-classes-request-schema';

export default abstract class GetClassesRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetClassesRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.classStartYear = data.classStartYear;
      this.periodFrom = data.periodFrom;
      this.periodTo = data.periodTo;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int32}
  */
  classStartYear?: number;
  /**
  * @type {date-time}
  */
  periodFrom?: string;
  /**
  * @type {date-time}
  */
  periodTo?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetClassesRequestDTO>): GetClassesRequestModel;
  static toModel(dto: DeepPartial<GetClassesRequestDTO> | undefined | null): GetClassesRequestModel | undefined;
  static toModel(dto: DeepPartial<GetClassesRequestDTO> | undefined | null): GetClassesRequestModel | undefined {
    return dto ? new GetClassesRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetClassesRequestModel> | GetClassesRequestModel): GetClassesRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      classStartYear: unwrapped.classStartYear,
      periodFrom: unwrapped.periodFrom,
      periodTo: unwrapped.periodTo,
      searchCriteria: unwrapped.searchCriteria,
    } as GetClassesRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetClassesRequestModel, can not map to GetClassesRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
